import React, { FC } from 'react';
import { ReactComponent as CircleTrash } from '../../../assets/Common/CircleTrash.svg';

export const CircleTrashIcon: FC = () => <CircleTrash />;
